module.exports = __webpack_public_path__ + "img/vlist.9b18c2ee.jpg";